export const ValueProposition = () => {
  const values = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cost Leadership',
      description: 'Replace expensive pulp with stable mineral fillers to secure profit margins.',
      stats: 'Up to 50% cost reduction',
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      icon: 'ri-flask-line',
      title: 'Scientific Validation',
      description: 'Proven technology backed by ACS Sustainable Chemistry & Engineering (2020).',
      stats: 'Peer-reviewed research',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Patent Protection',
      description: 'Comprehensive intellectual property coverage across major markets worldwide.',
      stats: 'Multi-jurisdiction patents',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Scalable Production',
      description: 'Industrial-grade synthesis process ready for immediate commercial deployment.',
      stats: 'Proven at scale',
      color: 'from-amber-500 to-amber-600'
    }
  ];

  return (
    <section id="value-proposition" className="py-24 bg-gradient-to-br from-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Why License <span className="text-amber-400">FCC Technology?</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Gain competitive advantage with proven, patented innovation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-slate-900/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 hover:border-amber-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/10"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${value.color} rounded-xl flex items-center justify-center mb-6 shadow-lg`}>
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">
                {value.title}
              </h3>
              <p className="text-gray-400 mb-4 leading-relaxed">
                {value.description}
              </p>
              <div className="inline-flex items-center bg-amber-500/10 border border-amber-500/30 px-4 py-2 rounded-lg">
                <i className="ri-check-line text-amber-400 mr-2"></i>
                <span className="text-sm font-semibold text-amber-400">{value.stats}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-amber-500/10 to-amber-600/10 border border-amber-500/30 rounded-2xl p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">
                Published Research Excellence
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-book-open-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2 text-lg">ACS Sustainable Chemistry & Engineering</h4>
                    <p className="text-gray-400 text-sm">Peer-reviewed publication validating FCC technology's environmental and economic benefits (2020)</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-microscope-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2 text-lg">Rigorous Testing & Validation</h4>
                    <p className="text-gray-400 text-sm">Comprehensive laboratory and industrial-scale trials confirming performance metrics</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-10 h-10 bg-amber-500 rounded-lg flex items-center justify-center mr-4 mt-1 flex-shrink-0">
                    <i className="ri-shield-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2 text-lg">Industry Recognition</h4>
                    <p className="text-gray-400 text-sm">Acknowledged by leading paper manufacturers and research institutions globally</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/88cd9e39a362e9f3874bb7565b655c04.jpg"
                alt="Research Laboratory"
                className="rounded-xl shadow-2xl object-cover w-full h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
